/** @file A project name from a PSD file name: extension dropped, slugified, deduped against taken names. */
import { slugifyName } from '@pose2d/format/slugifyName';

/** `My Hero v2.psd` → `My-Hero-v2` (`My-Hero-v2-2` when `taken` holds it); a name with no ASCII letters falls back
 *  to `layer-1` (slugifyName's rule). */
export function projectNameOf(fileName: string, taken: readonly string[] = []): string {
  return slugifyName(fileName.replace(/\.psd$/i, ''), new Set(taken), 1).name;
}
